import { useEffect } from "react";
import { connect } from "react-redux";
import { Note, Page } from "../../../helbest";
import { _set_i_user } from "../../../store/actions/login_actions";
import Header from "../Cart/Header/Header";
import { ReactComponent as EditIcon } from "./../../../assets/svg/edit.svg";
import styles from "./Profile.module.css";

import { ReactComponent as ArrowIcon } from "../../../assets/svg/arrow-right.svg";
import { ReactComponent as MyAddressIcon } from "../../../assets/svg/my-address.svg";
import { ReactComponent as MyOffersIcon } from "../../../assets/svg/my-offers.svg";
import { ReactComponent as MyOrdersIcon } from "../../../assets/svg/my-orders.svg";
import { ReactComponent as WalletIcon } from "../../../assets/svg/wallet.svg";

import { useMeQuery } from "../../../saleor/api";
import { UserAvatar } from "../../components/UserAvatar/UserAvatar";
import { useTranslation } from "react-i18next";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import { LangLink } from "../../components/LangLink/LangLink";

const Profile = (props) => {
  const navigate = useLangNavigate();
  const { t } = useTranslation();
  const { data: profileData } = useMeQuery({
    variables: {},
    onError: (err) => {
      Note.error(err.message);
    },
  });

  const check_user = () => {
    if (!props.Login.is_login) {
      navigate("/login/d/");
    }
  };

  useEffect(() => {
    check_user();
    // eslint-disable-next-line
  }, [props.Login.is_login]);

  useEffect(() => {
    if (profileData?.me) {
      props.dispatch(
        _set_i_user({
          first_name: profileData.me.firstName,
          last_name: profileData.me.lastName,
          email: profileData.me.email,
          phone_number: props.Login.phone_number,
          countryCode: props.Login.countryCode,
          user: { ...profileData.me },
        })
      );
    }
    // eslint-disable-next-line
  }, [profileData]);

  return (
    <Page
      className="page-profile"
      back={true}
      address="/"
      footer={<></>}
      customHeader={<HeaderBack url={"/"} title={t("profile.title")} />}
      headerFix
      logo
      showFooter
    >
      <div className="profile-data-box-container">
        <div className="profile-data-box">
          <div className="profile-title-flex">
            <h4>{t("profile.info_title")}</h4>
          </div>
          <div className="profile-title-flex">
            <div className="profile-title-flex gap-2">
              <UserAvatar />
              <div className="flex flex-column">
                <div>
                  <span className="profile-info-item">
                    {props.Login.first_name || "-"}{" "}
                    {props.Login.last_name || "-"}{" "}
                  </span>
                </div>
                <div>
                  <span
                    className="profile-info-item"
                    style={{ color: "#000", opacity: 0.4 }}
                  >
                    {props.Login.phone_number}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <LangLink className="edit-btn-profile" to="/profile/edit/">
                <EditIcon className={styles.EditIcon} />
              </LangLink>
            </div>
          </div>
          <hr className="mt-4 mb-0 global-hr" />
          {/* <hr className="mt-1 mb-1" /> */}
          {/* <div className="profile-data-body  ">
            <div className="row">
              <div className="col-sm-12 profile-data-body-line">
                <span className="profile-info-title"> First name </span>
                <span className="profile-info-item">
                  {" "}
                  {props.Login.first_name || "-"}{" "}
                </span>
              </div>
              <div className="col-sm-12 profile-data-body-line">
                <span className="profile-info-title"> Last name </span>
                <span className="profile-info-item">
                  {" "}
                  {props.Login.last_name || "-"}{" "}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 profile-data-body-line">
                <span className="profile-info-title"> Mobile Number </span>
                <span className="profile-info-item">
                  {" "}
                  {props.Login.phone_number}{" "}
                </span>
              </div>
            </div>
          </div> */}
        </div>

        <div className={styles.Links}>
          <LangLink to="/my-orders/" className={styles.Link}>
            <div className="flex items-center gap-4">
              <div className={styles.LinkIconContainer}>
                <MyOrdersIcon className={styles.LinkIcon} />
              </div>
              {t("profile.my.orders")}
            </div>
            <ArrowIcon className={styles.LinkArrow} />
          </LangLink>
          <LangLink to="/wallet/" className={styles.Link}>
            <div className="flex items-center gap-4">
              <div className={styles.LinkIconContainer}>
                <WalletIcon className={styles.LinkIcon} />
              </div>
              {t("profile.my.wallet")}
            </div>
            <ArrowIcon className={styles.LinkArrow} />
          </LangLink>
          <LangLink to="/offers/" className={styles.Link}>
            <div className="flex items-center gap-4">
              <div className={styles.LinkIconContainer}>
                <MyOffersIcon className={styles.LinkIcon} />
              </div>
              {t("profile.my.offers")}
            </div>
            <ArrowIcon className={styles.LinkArrow} />
          </LangLink>
          <LangLink to="/address/a/" className={styles.Link}>
            <div className="flex items-center gap-4">
              <div className={styles.LinkIconContainer}>
                <MyAddressIcon className={styles.LinkIcon} />
              </div>
              {t("profile.my.address")}
            </div>
            <ArrowIcon className={styles.LinkArrow} />
          </LangLink>
        </div>

        {/* <div className="row-profile-btn"> */}
        {/* <LangLink className="disabled" to="/ic/1/">افزایش اعتبار</LangLink> */}
        {/* <LangLink to="/factors/">My Factors</LangLink> */}
        {/* <LangLink to="/invoices/">
            {" "}
            <Button style_width={"100%"} style_marginTop={"8px"}>
              Invoices
            </Button>
          </LangLink> */}
        {/* <LangLink style={{width: '100%'}} to="/my-cards/">
                        <Button style_width={"100%"} style_marginTop={"8px"}>
                            My Cards
                        </Button>
                    </LangLink> */}
        {/* </div> */}
      </div>
    </Page>
  );
};

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(Profile);
